
export default {
  align: 'center',
  emptyBtn: false,
  submitText: '保存',
  printBtn: true,
  column: [
    {
      label: "主键id",
      prop: "id",
      display:false,

    },
    {
      label: "回访标识位",
      prop: "isReturnVisit",
      display:false,

    },

    {
      label: "回访方式",
      prop: "way",
      type: "select",
      span:24,
      dicUrl: "/api/blade-system/dict/dictionary?code=return_visit_way",
      dicData: [],
      props: {
        label: "dictValue",
        value: "dictKey",
      },
      rules: [
        {
          required: true,
          message: "请选择回访方式",
          trigger: "change",
        },
      ],
    },
    {
      label: "回访内容",
      prop: "content",
      span: 24,
      type: 'textarea',
      minRows: 6,
      maxlength: 500,
      rules: [
        {
          required: false,
          message: "请输入回访内容",
          trigger: "change"
        }
      ]
    },
  ],
};

